import React from "react";
import { Link } from "react-router-dom";
import { Home, ArrowRight, Compass } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import Seo from "../components/Seo";

const COPY = {
  tr: {
    title: "Sayfa Bulunamadı",
    heading: "Aradığınız sayfayı bulamadık",
    desc: "Bağlantı taşınmış, adı değişmiş veya hiç var olmamış olabilir. Aşağıdaki bağlantılardan devam edebilirsiniz.",
    home: "Ana Sayfa",
    services: "Hizmetler",
    blog: "Blog",
    contact: "İletişim",
    links: "Popüler sayfalar",
  },
  en: {
    title: "Page Not Found",
    heading: "We couldn't find that page",
    desc: "The link may have moved, been renamed, or never existed. You can continue from the links below.",
    home: "Home",
    services: "Services",
    blog: "Blog",
    contact: "Contact",
    links: "Popular pages",
  },
};

const NotFound = () => {
  const { lang } = useLanguage();
  const c = COPY[lang] || COPY.tr;

  const links = [
    { to: "/", label: c.home },
    { to: "/hizmetlerimiz", label: c.services },
    { to: "/blog", label: c.blog },
    { to: "/iletisim", label: c.contact },
  ];

  return (
    <>
      <Seo title={c.title} description={c.desc} noindex />
      <section
        className="min-h-screen bg-navy-950 flex items-center justify-center px-5 py-24"
        data-testid="not-found-page"
      >
        <div className="max-w-xl w-full text-center">
          <div className="inline-flex items-center gap-2 rounded-full border border-amber-500/30 bg-amber-500/10 px-4 py-1.5 text-sm font-semibold text-amber-400">
            <Compass className="w-4 h-4" /> 404
          </div>

          <h1 className="mt-8 font-display font-bold text-5xl sm:text-6xl text-white tracking-tight">
            404
          </h1>
          <h2 className="mt-4 font-display font-semibold text-lg md:text-lg text-slate-200">
            {c.heading}
          </h2>
          <p className="mt-4 text-base text-slate-400 leading-relaxed">{c.desc}</p>

          <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/"
              data-testid="not-found-home-btn"
              className="inline-flex items-center gap-2 rounded-lg bg-amber-500 hover:bg-amber-400 text-navy-950 font-semibold px-6 py-3 transition-colors"
            >
              <Home className="w-4 h-4" /> {c.home}
            </Link>
            <Link
              to="/iletisim"
              data-testid="not-found-contact-btn"
              className="inline-flex items-center gap-2 rounded-lg border border-white/15 text-slate-200 hover:border-amber-500/40 hover:text-white font-semibold px-6 py-3 transition-colors"
            >
              {c.contact} <ArrowRight className="w-4 h-4" />
            </Link>
          </div>

          <div className="mt-14 pt-8 border-t border-white/10">
            <p className="text-xs uppercase tracking-wider text-slate-500 mb-4">{c.links}</p>
            <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
              {links.map((l) => (
                <Link
                  key={l.to}
                  to={l.to}
                  className="text-sm text-slate-300 hover:text-amber-400 transition-colors"
                >
                  {l.label}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default NotFound;
